module.exports = __webpack_public_path__ + "img/section-title1.180677ee.png";